// components/Header.jsx
import React, { Component } from 'react';
import { Modal, Divider, message, Input, Button, } from 'antd';
import PubSub from 'pubsub-js'
import withRouterNavigate from './withRouterNavigate.js'; // 注意路径
import { meshLog, SPRemove, SPGet, SPSet } from "../../../utils/spUtils";
import './header.less';
import { OUTPUT_PROFILE_DIALOG_SHOW, PERMISSION_DIALOG_SHOW, deviceNo } from "../../../const/infoConst"
import { sendEmailVerificationCodedelet, deleteuser } from "../../../utils/net/netManager";
import logo from '../../../imgs/logo/logo2.png';
import top_profile from '../../../imgs/btn/top_profile.png';
import shareBtn from '../../../imgs/btn/shareBtn.png';
import top_user from '../../../imgs/btn/top_user.png';
import top_arrow from '../../../imgs/btn/top_arrow.png';



const { confirm } = Modal;

class Header extends Component {
    constructor(props) {
        super(props);
        this.state = {
            menuOpen: false,
            useName: "name",
            logOut: false,
            delete: false,
            countdown: 0,
            setCode: 0
        };
    }



    componentDidMount() {
        let useName = SPGet('useName')
        meshLog('usename', useName);
        this.setState({
            useName: useName,
        })

        PubSub.unsubscribe("controlMenuOpen")
        PubSub.subscribe('controlMenuOpen', (msg, index) => {
            //状态更新
            this.setState({
                menuOpen: false
            })
        })
    }
    componentWillUnmount() {
        clearInterval(this.countdownInterval);
    }

    //分享弹窗
    shareClick() {
        PubSub.publish(PERMISSION_DIALOG_SHOW, '')
    }

    //弹出下拉框
    toggleMenu() {
        let menuOpen = this.state.menuOpen
        this.setState({
            menuOpen: !menuOpen
        })
    }

    //下拉框--信息（暂无）
    infoClick() {
        this.setState({
            menuOpen: false,
        })
        message.warning({ content: 'Not ready', style: { fontSize: "25px" } });
    }

    //下拉框--导出数据弹窗
    outputDialog() {
        this.setState({
            menuOpen: false,
        })
        PubSub.publish(OUTPUT_PROFILE_DIALOG_SHOW, '')
    }

    //下拉框--退出登录弹窗
    logOutClick() {
        //console.log(444)
        this.setState({
            menuOpen: false,
            logOut: true,
            delete: false
        })
    }

    //退出登录-确认
    handleOk = () => {
        PubSub.publish('clearmqtt', '')
        SPRemove("energy_SelectBuildingName")
        SPRemove("energy_SelectMeshName")
        SPRemove("energy_groupList")
        this.props.navigate('/login');
        this.setState({
            logOut: false
        })
    }

    //退出登录-取消
    handleCancel = () => {
        this.setState({
            logOut: false
        })
    }

    //下拉框--删除弹窗
    deleteClick() {
        //console.log(444)
        this.setState({
            menuOpen: false,
            logOut: false,
            delete: true
        })
    }

    // 获取验证码
    sendCode = async (value) => {
        const email = (SPGet("email"))
        const type = 1
        // console.log('email value:', email);
        if (email) {
            try {
                this.setState({ countdown: 60 }, () => {
                    this.countdownInterval = setInterval(() => {
                        this.setState((prev) => {
                            if (prev.countdown <= 1) {
                                clearInterval(this.countdownInterval);
                                return { countdown: 0 };
                            }
                            return { countdown: prev.countdown - 1 };
                        });
                    }, 1000);
                });
            } catch (error) {
                message.error({ content: 'Failed to send verification code.', style: { fontSize: "25px" } });
            }
            let result = await sendEmailVerificationCodedelet(email, type)
            const { code, msg } = result;
            meshLog('result', result);
            //if (code === 0 && msg.meshList.length > 0) {
            if (code === 0) {
                // alert('send verification code success')
            } else {
                message.error({ content: 'Failed to send verification code.', style: { fontSize: "25px" } });
            }

        } else {
            message.error({ content: 'Email cannot be empty.', style: { fontSize: "25px" } });
        }

    };

    //删除-确认
    handleDeleteOk = async (value) => {

        let token = SPGet('token')
        let maddr = SPGet('email')
        const verificationCode = this.state.setCode
        meshLog('verificationCode', this.state.setCode);
        let result = await deleteuser(maddr, verificationCode, token, deviceNo);
        const { code, msg } = result;
        if (code === 0) {
            // alert('Delete successfully')
            PubSub.publish('clearmqtt', '')
            SPRemove("energy_SelectBuildingName")
            SPRemove("energy_SelectMeshName")
            SPRemove("energy_groupList")
            this.props.navigate('/login');
            this.setState({
                delete: false
            })
        } else {
            message.error({ content: 'Delete failed.', style: { fontSize: "25px" } });
        }


    }

    //退删除-取消
    handleDeleteCancel = () => {
        this.setState({
            delete: false
        })
    }

    setCode = (value) => {
        this.setState({
            setCode: value
        })
    }


    //

    render() {
        const { menuOpen, countdown } = this.state;

        return (
            <div className='header'>
                <div className='logo'>
                    <img src={logo} alt="logo" className="logo" />
                </div>
                <div className='userSection'>
                    <img className='btn1' src={shareBtn} onClick={() => { this.shareClick() }} />
                    <Divider className='line1' type="vertical" dashed='true' />
                    <div className='user' onClick={() => { this.toggleMenu() }}>
                        <img className='btn3' src={top_user} />
                        <img className='arrow' src={top_arrow} />
                    </div>

                    <Modal
                        title="Basic Modal"
                        closable={{ 'aria-label': 'Custom Close Button' }}
                        open={this.state.logOut}
                        onOk={this.handleOk}
                        onCancel={this.handleCancel}
                    >
                        <h2>LOGOUT</h2>
                        <h5>Logging out will clear local data. Are you sure?</h5>

                    </Modal>

                    <Modal
                        title="Basic Modal"
                        closable={{ 'aria-label': 'Custom Close Button' }}
                        open={this.state.delete}
                        onOk={this.handleDeleteOk}
                        onCancel={this.handleDeleteCancel}
                    >
                        <h2>delete</h2>
                        <div style={{ display: 'flex' }}>
                            <Input style={{ width: 210, height: 45, borderRadius: 8 }} onChange={(e) => { this.setCode(e.target.value) }} placeholder="*Verification Code" />
                            <Button
                                type="primary"
                                onClick={this.sendCode}
                                disabled={countdown > 0}
                                style={{ width: 120, marginLeft: 20, height: 45, borderRadius: 8, backgroundColor: '#0a46bd' }}>
                                {countdown > 0 ? `${countdown}s` : 'Send Code'}
                            </Button>
                        </div>
                        <h5>delete will clear local data. Are you sure?</h5>

                    </Modal>

                    {menuOpen && (
                        <div className='dropdown'>
                            <div className='item' onClick={() => { this.infoClick() }}>Information</div>
                            <div className='item' onClick={() => { this.outputDialog() }} >Overall Project Report</div>
                            <div className='item' onClick={() => { this.deleteClick() }} >delete</div>
                            <div className='item' onClick={() => { this.logOutClick() }} >logOut</div>
                        </div>
                    )}

                </div>
            </div>
        );
    }
}
export default withRouterNavigate(Header)
